/**
 * ScrollToTop — resets scroll position to the top on every route change.
 *
 * SPA navigations keep the previous scroll offset by default, so clicking a
 * link could land the visitor mid-page (looking at a random section instead of
 * the hero). We reset on pathname change but honour in-page #anchors.
 */
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useLayoutEffect(() => {
        if (hash) return; // let the browser jump to #anchor targets
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
}
